"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTime = exports.cachifyPromise = void 0;
var defaults_1 = require("./defaults");
var cleanup_1 = require("./lib/cleanup");
var execute_promise_1 = require("./lib/execute-promise");
var increment_stats_value_1 = require("./lib/increment-stats-value");
var is_expired_1 = require("./lib/is-expired");
var log_1 = require("./lib/log");
__exportStar(require("./types/cache-entry"), exports);
__exportStar(require("./types/cache-options"), exports);
__exportStar(require("./types/item-storage"), exports);
__exportStar(require("./types/promise-returning-function"), exports);
__exportStar(require("./types/stats"), exports);
function cachifyPromise(fn, cacheOptions) {
    var opts = Object.assign({}, defaults_1.getDefaultCacheOptions(), cacheOptions);
    var state = {
        cacheMap: opts.cacheMap,
        promiseCacheMap: {},
        stats: {
            hitValue: 0,
            hitPromise: 0,
            miss: 0,
            put: 0
        }
    };
    var cachedFunction = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = opts.cacheKeyFn.apply(opts, __spread(args));
        var foundPromise = state.promiseCacheMap[key];
        if (foundPromise && !(opts.staleWhileRevalidate && state.cacheMap.has(key))) {
            log_1.log(opts, "Promise cache hit for '" + key + "'");
            increment_stats_value_1.incrementStatsValue(state, opts, 'hitPromise');
            return foundPromise;
        }
        if (state.cacheMap.has(key)) {
            var entry = state.cacheMap.get(key);
            if (!is_expired_1.isExpired(opts, entry)) {
                log_1.log(opts, "Cache hit for '" + key + "'");
                increment_stats_value_1.incrementStatsValue(state, opts, 'hitValue');
                return Promise.resolve(entry.data);
            }
            else {
                // expired
                if (opts.staleWhileRevalidate) {
                    if (state.promiseCacheMap[key]) {
                        log_1.log(opts, "Stale cache hit for '" + key + "', but already revalidating");
                    }
                    else {
                        log_1.log(opts, "Stale cache hit for '" + key + "', revalidating");
                        execute_promise_1.executePromise(state, opts, fn, key, args).catch(function (err) {
                            log_1.log(opts, "Failed to do stale revalidation for '" + key + "' in background: " + err);
                        });
                    }
                    return Promise.resolve(entry.data);
                }
                else {
                    state.cacheMap.delete(key);
                    if (state.cacheMap.size === 0) {
                        cleanup_1.stopCleanupJob(state, opts);
                    }
                }
            }
        }
        increment_stats_value_1.incrementStatsValue(state, opts, 'miss');
        log_1.log(opts, "Cache miss for '" + key + "', fetching...");
        return execute_promise_1.executePromise(state, opts, fn, key, args);
    };
    return Object.assign(cachedFunction, {
        delete: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var key = opts.cacheKeyFn.apply(opts, __spread(args));
            log_1.log(opts, "Deleting " + key + " from cache");
            return state.cacheMap.delete(key);
        }
    });
}
exports.cachifyPromise = cachifyPromise;
exports.getTime = function () {
    return new Date().getTime();
};
//# sourceMappingURL=cache-promise.js.map